module.exports = __webpack_public_path__ + "static/media/frames-19.4afedfbc.jpg";